<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">

            <!-- USER PROFILE SIDEBAR -->
            <!-- <user-profile :active="activeProfileSidebar" :userId="userProfileId" class="user-profile-container" :isLoggedInUser="isLoggedInUserProfileView" @closeProfileSidebar="closeProfileSidebar"></user-profile> -->

            <div class="chat__profile-search flex p-4">
                <!-- <div class="relative inline-flex">
                    <vs-avatar v-if="activeUser.photoURL" class="m-0 border-2 border-solid border-white" :src="activeUser.photoURL" size="40px" @click="showProfileSidebar(activeUser.userId, true)" />
                    <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(true)"></div>
                </div> -->
                <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full mx-5 input-rounded-full" placeholder="Search or start a new chat" v-model="searchQuery"/>

                <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon" @click="toggleChatSidebar(false)" />
            </div>

            <vs-divider class="d-theme-border-grey-light m-0" />
            <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl">

                <!-- ACTIVE CHATS LIST -->
                <div class="chat__chats-list mb-8">
                    <!-- <h3 class="text-primary mb-5 px-4">Chats</h3> -->
                    <ul class="chat__active-chats bordered-items">
                        <li class="cursor-pointer" v-for="(contact, index) in chatContacts" :key="index" @click="updateActiveChatUser(contact.organizationId)">
                            <chat-contact showLastMsg :contact="contact" :lastMessaged="chatLastMessaged(contact.organizationId).time" :unseenMsg="chatUnseenMessages(contact.organizationId)" :isActiveChatUser="isActiveChatUser(contact.organizationId)"></chat-contact>
                        </li>
                    </ul>
                </div>


                <!-- CONTACTS LIST -->
                <!-- <div class="chat__contacts">
                    <h3 class="text-primary mb-5 px-4">Contacts</h3>
                    <ul class="chat__contacts bordered-items">
                        <li class="cursor-pointer" v-for="contact in contacts" :key="contact.uid" @click="updateActiveChatUser(contact.uid)">
                            <chat-contact :contact="contact"></chat-contact>
                        </li>
                    </ul>
                </div> -->
            </component>
        </vs-sidebar>

        <!-- RIGHT COLUMN -->
        <div class="chat__bgg bg-img no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': activeChatUser === null}">
            <template v-if="activeChatUser">
                <div class="chat__navbar">
                    <chat-navbar :isSidebarCollapsed="!clickNotClose" :user-id="activeChatUser" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
                </div>
                <component :is="scrollbarTag" class="chat-content-scroll-area border border-solid d-theme-border-grey-light" :settings="settings" ref="chatLogPS" :key="$vs.rtl">
                    <div class="chat__log" ref="chatLog">
                        <chat-log :userId="activeChatUser" v-if="activeChatUser"></chat-log>
                    </div>
                </component>
                <div class="chat__input flex p-4 bg-white">
                    <vs-input class="flex-1" placeholder="Type Your Message" v-model="typedMessage" @keyup.enter="sendMsg" @keypress="userTyping" />
                    <vs-button class="bg-primary-gradient ml-4" type="filled" @click="sendMsg">Send</vs-button>
                </div>
            </template>
            <template v-else>
                <div class="flex flex-col items-center">
                    <feather-icon icon="MessageSquareIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16"></feather-icon>
                    <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" @click.stop="toggleChatSidebar(true)">Start Conversation</h4>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ChatContact         from './MessagesContact.vue'
import ChatLog             from './MessagesLog.vue'
import ChatNavbar          from './MessagesNavbar.vue'
import UserProfile         from './UserProfile.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleChat          from '@/store/user-chat/moduleChat.js'
import { encrypt, decrypt } from '@/utils/e2e/EncryptDecrypt.js';


export default {
  data () {
    return {
      active               : true,
      isHidden             : false,
      searchContact        : '',
      activeProfileSidebar : false,
      activeChatUser       : null,
      userProfileId        : -1,
      typedMessage         : '',
      isChatPinned         : false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.70
      },
      clickNotClose        : true,
      isChatSidebarActive  : true,
      isLoggedInUserProfileView: false,
      isUserTyping: false
    }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    },
    userData(newVal) {
      if(newVal) {
        // Fetch chat contacts by user Id
        // // console.log('userid', newVal._id);
        this.$store.dispatch("userChat/fetchChatContactsByUserId", newVal._id).catch(err => { throw err; });

        // Fetch chats
        this.$store.dispatch('userChat/fetchChatsByUserId', this.userData._id).catch(err => { throw err; });

        //
        this.$socket.connect();
        this.$socket.emit("attachUser", { userId: newVal._id });
      }
    },
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    chatLastMessaged () {
      return (userId) => this.$store.getters['userChat/chatLastMessaged'](userId)
    },
    chatUnseenMessages () {
      return (userId) => {
        const unseenMsg = this.$store.getters['userChat/chatUnseenMessages'](userId)
        if (unseenMsg) return unseenMsg
      }
    },
    activeUser () {
      return this.$store.state.AppActiveUser
    },
    getStatusColor () {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    },
    chatContacts () {
      return this.$store.getters['userChat/chatContacts']
    },
    contacts () {
      return this.$store.getters['userChat/contacts']
    },
    searchQuery: {
      get () {
        return this.$store.state.userChat.chatSearchQuery
      },
      set (val) {
        this.$store.dispatch('userChat/setChatSearchQuery', val)
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    isActiveChatUser () {
      return (userId) => userId === this.activeChatUser
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    getUserStatus (isActiveUser) {
      // return "active"
      return isActiveUser ? this.$store.state.AppActiveUser.status : this.contacts[this.activeChatUser].status
    },
    closeProfileSidebar (value) {
      this.activeProfileSidebar = value
    },
    updateActiveChatUser (contactId) {
      this.activeChatUser = contactId
      if (this.$store.getters['userChat/chatDataOfUser'](this.activeChatUser)) {
        // this.$store.dispatch('userChat/markSeenAllMessages', contactId)
      }
      const chatData = this.$store.getters['userChat/chatDataOfUser'](this.activeChatUser)
      // if (chatData) this.isChatPinned = chatData.isPinned
      // else this.isChatPinned = false
      this.isChatPinned = false
      this.toggleChatSidebar()
      this.typedMessage = ''
    },
    showProfileSidebar (userId, openOnLeft = false) {
      this.userProfileId = userId
      this.isLoggedInUserProfileView = openOnLeft
      this.activeProfileSidebar = !this.activeProfileSidebar
    },
    userStoppedTyping(){
      this.isUserTyping = false;
      this.$socket.emit('sendStopTyping', {to:  { receiverType: 'organization', organizationId: this.activeChatUser }});
    },
    userTyping() {
      if(this.isUserTyping == false) {
        this.isUserTyping = true
        this.$socket.emit('sendTyping', {to:  { receiverType: 'organization', organizationId: this.activeChatUser }});
        this.typingTimeout = setTimeout(this.userStoppedTyping, 2500);
      } else {
        clearTimeout(this.typingTimeout);
        this.timeout = setTimeout(this.userStoppedTyping, 2500);
      }
    },
    sendMsg () {
      if (!this.typedMessage) return

      // Stop typing
      // clearTimeout(this.typingTimeout);
      // this.timeout = setTimeout(this.userStoppedTyping, 2500);

      // Encrypt Message
      const encryptObj = encrypt(this.typedMessage);
      const message = {
        encryptedData: encryptObj.encryptedData,
        key: encryptObj.key,
        iv: encryptObj.iv
      }

      const payload = {
        'isPinned': this.isChatPinned,
        'msg': {
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : true,
          'isSeen'      : false
        },
        'id': this.userData._id,
        message,
        sentByUserId: this.userData._id,
        receivedByUserId: this.activeChatUser,
        organizationId: this.activeChatUser
      }
      this.$store.dispatch('userChat/sendChatMessage', payload)
      // this.typedMessage = ''

      const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
      scroll_el.scrollTop = this.$refs.chatLog.scrollHeight

      // // console.log(this.$socket.id);

      // Socket
      this.$socket.emit("sendMessage", {
        payload,
        to:  { receiverType: 'organization', organizationId: this.activeChatUser }
      });

      this.typedMessage = ''
    },
    toggleIsChatPinned (value) {
      this.isChatPinned = value
    },
    setSidebarWidth () {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    }
  },
  components: {
    VuePerfectScrollbar,
    ChatContact,
    UserProfile,
    ChatNavbar,
    ChatLog
  },
  created () {
    
    if(this.userData && this.userData._id) {
      // Fetch chat contacts by user Id
      // // console.log('userid', this.userData._id);
      this.$store.dispatch("userChat/fetchChatContactsByUserId", this.userData._id).catch(err => { throw err; });

      // Fetch chats
      this.$store.dispatch('userChat/fetchChatsByUserId', this.userData._id).catch(err => { throw err; });

      // socketio connection
      this.$socket.connect();
      this.$socket.emit("attachUser", { userId: this.userData._id });
    }
    // this.$store.registerModule('chat', moduleChat)
    // this.$store.dispatch('userChat/fetchContacts')
    // this.$store.dispatch('userChat/fetchChatContacts')
    // this.$store.dispatch('userChat/fetchChats')
    this.setSidebarWidth()

    // On Browser tab closed
    document.addEventListener('beforeunload', () => {
      // close socket connection
      this.$socket.emit("detachUser", { userId: this.userData._id });
      this.$socket.disconnect()
    });
  },
  beforeDestroy () {
    this.$store.unregisterModule('chat');

    // close socket connection
    this.$socket.emit("detachUser", { userId: this.userData._id });
    this.$socket.disconnect()
  },
  mounted () {
    this.$store.dispatch('userChat/setChatSearchQuery', '')

    // // console.log(this.$socket.subscribe);

    /*const payload = {
        'isPinned': this.isChatPinned,
        'msg': {
          'textContent' : this.typedMessage,
          'time'        : String(new Date()),
          'isSent'      : false,
          'isSeen'      : false
        },
        'id': 2,
        message: this.typedMessage,
        sentByUserId: this.userData._id,
        receivedByUserId: '60bd200c6736a12184c15cac',
        organizationId: '60bd200c6736a12184c15cac'
      }*/

    this.sockets.subscribe('receiveMessage', data => {
      // // console.log('receiveMessage', data);

      if(!data.payload.createdAt) {
        data.payload.createdAt = new Date();
      }

      this.$store.commit('userChat/RECEIVE_CHAT_MESSAGE', data.payload);
    });

    // Handler for disconnection
    let connectHandle;
    this.sockets.subscribe('disconnect', () => {
      connectHandle = setInterval(() => {
        this.$socket.connect();
        this.$socket.emit("attachUser", { userId: this.userData._id });
      }, 1000);
    });
    this.sockets.subscribe('connect', () => {
        clearInterval(connectHandle);
    });
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>
